// Verification-gate reason codes -> UI labels + human-readable descriptions.
// Codes come from the backend gate (services/verification.py -> verification_flags.reasons).
// Shared by the Listings table "Needs" column and the Listing edit modal so the two
// never drift.

export const REASON_LABELS = {
  beds_baths_mismatch: "beds/baths",
  floor_missing: "floor",
  floor_line_missing: "floor line",
  sqft_missing: "sqft",
  hoa_missing: "HOA",
  tax_missing: "tax",
  reno_no_description: "reno",
  reno_high_no_dw: "reno+DW",
  no_se_source: "SE link",
  whole_building_unit: "whole-bldg",
  possible_relist_dupe: "relist?",
};

// Fuller, sentence-length explanation of what's missing / wrong — used where there's
// room to spell it out (the edit modal), so a reviewer knows what to fix.
export const REASON_DESCRIPTIONS = {
  beds_baths_mismatch: "Beds/baths disagree across sources — confirm the correct count",
  floor_missing: "Floor is missing — set the unit's floor",
  floor_line_missing: "Floor line (stack) is missing",
  sqft_missing: "Square footage is missing or only estimated — enter a verified sqft",
  hoa_missing: "HOA / common charges are missing",
  tax_missing: "Monthly taxes are missing",
  // ⚠️ The CODE says description; the RULE does not. The gate raises this when
  // `ai_renovation` is null or 0 — "the AI has not scored this listing, or scored it 0
  // meaning it could not tell" — and it never looks at the description table at all. A
  // listing with 1,675 characters of RealPlus copy carried this reason for a day because the
  // gate ran before the AI did (25 BOND ST #5, 1494021), and the old wording sent the
  // reviewer off to StreetEasy to look for a description that was already in our own
  // database. Say what is actually missing. The key is left alone: it is stored in
  // verification_flags on hundreds of live rows.
  reno_no_description:
    "Renovation level not set — the AI hasn't scored this listing yet, or couldn't tell from its description",
  reno_high_no_dw: "High-reno unit with no dishwasher — confirm the dishwasher",
  no_se_source: "No StreetEasy link on file — add one",
  whole_building_unit: "Looks like a whole-building sale, not an individual unit",
  possible_relist_dupe: "Possible relist / duplicate — resolve it below",
};
